const children = [
  {
    path: '/login/agreement',
    name: 'LoginAgreement',
    component: () => import('@/views/login/agreement'),
    meta: { title: '实名制登记用户协议、隐私政策' }
  },
  {
    path: '/login/:name',
    name: 'Login',
    component: () => import('@/views/login/login'),
    meta: { title: '登录' }
  },
  {
    path: '/user/help',
    name: 'Help',
    meta: { title: '帮助' },
    component: () => import('@/views/user/help')
  }
]
console.log('process.env.DISABLE_LOGIN', process.env.DISABLE_LOGIN)
if (process.env.DISABLE_LOGIN === true) {
  children.splice(1, 1)
}

const router = {
  path: '/login',
  name: 'Login',
  meta: { title: '登录' },
  redirect: '/login/business',
  component: () => import('@/components/Layout'),
  children
}
export default router



// WEBPACK FOOTER //
// ./src/router/login.js